export default __webpack_public_path__ + "static/media/Mic_Off.c0f51294.svg";